var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { observable, reaction, runInAction, toJS } from 'mobx';
import ErrorUtil from '../util/ErrorUtil';
import { FetchStatus } from '../util/FetchStatus';
const GRAVITY_FORMS_APP_NAME = 'gravityforms';
let TranslateStore = (() => {
    var _a, _TranslateStore_translations_accessor_storage, _TranslateStore_translationsFetchStatus_accessor_storage;
    var _b, _c;
    let _translations_decorators;
    let _translations_initializers = [];
    let _translations_extraInitializers = [];
    let _translationsFetchStatus_decorators;
    let _translationsFetchStatus_initializers = [];
    let _translationsFetchStatus_extraInitializers = [];
    return _a = class TranslateStore {
            get translations() { return __classPrivateFieldGet(this, _TranslateStore_translations_accessor_storage, "f"); }
            set translations(value) { __classPrivateFieldSet(this, _TranslateStore_translations_accessor_storage, value, "f"); }
            get translationsFetchStatus() { return __classPrivateFieldGet(this, _TranslateStore_translationsFetchStatus_accessor_storage, "f"); }
            set translationsFetchStatus(value) { __classPrivateFieldSet(this, _TranslateStore_translationsFetchStatus_accessor_storage, value, "f"); }
            constructor(rootStore) {
                _TranslateStore_translations_accessor_storage.set(this, __runInitializers(this, _translations_initializers, {}));
                _TranslateStore_translationsFetchStatus_accessor_storage.set(this, (__runInitializers(this, _translations_extraInitializers), __runInitializers(this, _translationsFetchStatus_initializers, FetchStatus.UNINITIALIZED)));
                Object.defineProperty(this, "propStateStore", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: __runInitializers(this, _translationsFetchStatus_extraInitializers)
                });
                Object.defineProperty(this, "api", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "translate", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: (key, params, group = GRAVITY_FORMS_APP_NAME) => {
                        const label = `${group}:${key}`;
                        if (this.translations && this.translations[group] && this.translations[group][key]) {
                            const value = this.translations[group][key];
                            if (params) {
                                return this.parseTextParams(value, params);
                            }
                            return value;
                        }
                        this.logErrorIfNeeded(label);
                        return label;
                    }
                });
                Object.defineProperty(this, "logErrorIfNeeded", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: (label) => {
                        if (Object.keys(this.translations || {}).length) {
                            const error = new Error('Translation missing');
                            error.stack = `label: ${label} , page: ${window.location.pathname}`;
                            ErrorUtil.pushErrorToTeliaRum(error);
                            if (typeof process !== 'undefined' && process.env.JEST_WORKER_ID === undefined) {
                                console.error(error);
                            }
                        }
                    }
                });
                Object.defineProperty(this, "parseTextParams", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: (textValue, paramObject) => {
                        return Object.keys(paramObject).reduce((text, key) => text.replace(`$\{${key}}`, paramObject[key]), textValue);
                    }
                });
                Object.defineProperty(this, "fetchJson", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: async (url) => {
                        try {
                            runInAction(() => (this.translationsFetchStatus = FetchStatus.FETCHING));
                            return await this.api.get(url);
                        }
                        catch (error) {
                        }
                        return null;
                    }
                });
                Object.defineProperty(this, "updateTranslations", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: async () => {
                        var _b;
                        const url = `/translations/${this.propStateStore.currentLanguage}?appNames=${GRAVITY_FORMS_APP_NAME}`;
                        const response = await this.fetchJson(url);
                        if ((_b = response.data) === null || _b === void 0 ? void 0 : _b.translations) {
                            this.setTranslations(response.data.translations);
                        }
                        runInAction(() => (this.translationsFetchStatus = FetchStatus.FETCHED));
                    }
                });
                this.propStateStore = rootStore.propStateStore;
                this.api = rootStore.api;
                this.updateTranslations();
                reaction(() => this.propStateStore.currentLanguage, () => this.updateTranslations());
            }
            setTranslations(translations) {
                runInAction(() => {
                    this.translations = toJS(translations);
                });
            }
        },
        _TranslateStore_translations_accessor_storage = new WeakMap(),
        _TranslateStore_translationsFetchStatus_accessor_storage = new WeakMap(),
        (() => {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _translations_decorators = [(_b = observable).struct.bind(_b)];
            _translationsFetchStatus_decorators = [(_c = observable).struct.bind(_c)];
            __esDecorate(_a, null, _translations_decorators, { kind: "accessor", name: "translations", static: false, private: false, access: { has: obj => "translations" in obj, get: obj => obj.translations, set: (obj, value) => { obj.translations = value; } }, metadata: _metadata }, _translations_initializers, _translations_extraInitializers);
            __esDecorate(_a, null, _translationsFetchStatus_decorators, { kind: "accessor", name: "translationsFetchStatus", static: false, private: false, access: { has: obj => "translationsFetchStatus" in obj, get: obj => obj.translationsFetchStatus, set: (obj, value) => { obj.translationsFetchStatus = value; } }, metadata: _metadata }, _translationsFetchStatus_initializers, _translationsFetchStatus_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { TranslateStore };
export default TranslateStore;
//# sourceMappingURL=TranslateStore.js.map